import Vue from 'vue'

const state = {
    royalBonuses: {
        birthday: 0,
        each_day: 0,
        macau: 0,
        macau2018: 0,
        royal: 0
    }
};

const getters = {
    royalBonuses: state => {
        return state.royalBonuses;
    }
};

const mutations = {
    setRoyalBonuses(state, data) {
        Vue.set(state, 'royalBonuses', {
            birthday: data.birthday,
            each_day: data.each_day,
            macau: data.macau,
            macau2018: data.macau2018,
            royal: data.royal
        });
    }
};

export default {
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/royalBonuses.js